<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.AuthorizedClient')"
    width="440px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    :append-to-body="true"
    top="5vh"
    custom-class="details-view customer-popup"
  >
    <div class="main-content">
      <div style="flex-direction:column;">
        <el-form label-width="70px" label-position="right" style="height: 70px">
          <el-form-item :label="$t('Pricing.AuthorizedClient')">
            <cargo-company-select
              no="customerId"
              :method-params="{customer:true,active:true}"
              :default-value="customerId"
              @change="p=>{customerId=p.value}"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;">
          <el-button no="customerOkEventHandler" type="primary" size="mini" @click="customerOkEventHandler">{{ $t('Pricing.OK') }}</el-button>
          <el-button no="onCancel" size="mini" @click="onCancel">{{ $t('Pricing.CANCEL') }}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { checkCompany } from '@/api/company'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'CustomerPopup',
  components: { CargoCompanySelect, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      fullscreenLoading: null,
      customerId: 0,
      config: null,
      validateCustomerSales: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.config = cache.config
      this.validateCustomerSales = parseInt(this.config.get('BookingValidateCustomerSales')) === 1
    },
    customerOkEventHandler(p) {
      if (!this.customerId) {
        this.$message.warning(this.$t('Pricing.ClientIsEmpty'))
        return
      }
      if (this.$store.getters.isAdmin || !this.validateCustomerSales) {
        this.$emit('ok', this.customerId)
      } else {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', parseInt(this.customerPopup.customerId))
        if (!company || !company.uuid) return
        checkCompany({ sales: this.$store.getters.userId, companyUuid: company.uuid }).then(res => {
          if (!res.data) {
            this.$message.warning(this.$t('Price.TheBelongToYourSelect'))
            return
          }
          this.$emit('ok', this.customerId)
        })
      }
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
</style>
